import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import EntryComplete from './entry-complete';
import EntryConfirm from './entry-confirm';
import EntryCreatePage from './entry-create';

export default function EntryPage() {
  useEffect(() => {
    window.scrollTo(0, 0);

  }, []);

  return (
    <Switch>
      <Route exact path="/entry/recruit/:jobType" component={() => <EntryCreatePage entryType='recruit' />} />
      <Route exact path="/entry/recruit/:jobType/confirm" component={() => <EntryConfirm entryType='recruit' />} />
      <Route exact path="/entry/recruit/:jobType/complete" component={() => <EntryComplete entryType='recruit' />} />
      <Route exact path="/entry/visit/:jobType" component={() => <EntryCreatePage entryType='visit' />} />
      <Route exact path="/entry/visit/:jobType/confirm" component={() => <EntryConfirm entryType='visit' />} />
      <Route exact path="/entry/visit/:jobType/complete" component={() => <EntryComplete entryType='visit' />} />
    </Switch>
  );
}
